import { Base } from "../core/base.model";


export class Cliente extends Base {

    public id: number;
	public razonsocial: string;
	public rfc: string;

	public representante: string;
	public email: string;
	public telefono: string;
	public comentarios: string;
	public estatus: string;
	public fechaAlta: Date;
	
	public idcorporativo: number;
	public idempresa: number;

	public idtipo : number;
	public idsegmento : number;
	public idtamanio : number;
	public formacontacto : string;
	public nombreContacto: string;
	public extensionTel: number;
	public esProspecto: number;
	public idProyecto: string;
	public nombre_corto: string;
}